module.exports = __webpack_public_path__ + "img/PW.d3abcbaa.svg";